
import queryString from 'query-string'
import 'whatwg-fetch'
import { apiURL } from '../baseURL';
import { _getData, jsonPipe } from './fetch';
import { handleVote } from '../Storage';

const _sendVotes = (_ID, _voteType, _callback) => {
    return fetch(`${apiURL}sendvote`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(_voteType ? {
            ID: _ID,
            VoteLike: 1,
            VoteDislike: 0
        } : {
                ID: _ID,
                VoteDislike: 1,
                VoteLike: 0
            })
    }).then(() => {
        handleVote.set(`Vote_${_ID}`, true)
        _callback()
    });
}
const _getVotes = {
    byID: (_ID) => _getData(`${apiURL}getVote/${_ID}`).then(jsonPipe),
    All: () =>  _getData(`${apiURL}getVotes?t=${new Date().getMinutes()}`).then(jsonPipe)
}

export {
    _sendVotes,
    _getVotes
}


// WEBPACK FOOTER //
// ./src/Components/Services/Fetch/votes.js